import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import { paths } from './routes/paths';
import AppLayout from './components/layout/AppLayout/AppLayout';
import LoginPage from './pages/LoginPage/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage/AuthCallbackPage';
import WorkspacesPage from './pages/WorkspacesPage/WorkspacesPage';
import WorkspacePage from './pages/WorkspacePage/WorkspacePage';
import { WorkspacesProvider } from './context/WorkspacesContext'; // Seu novo Contexto importado aqui
import WorkspaceSettingsPage from './pages/WorkspaceSettingsPage/WorkspaceSettingsPage';
import CodexPage from './pages/CodexPage/CodexPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path={paths.login} element={<LoginPage />} />
          <Route path={paths.authCallback} element={<AuthCallbackPage />} />

          {/* Authenticated */}
          <Route element={<ProtectedRoute />}>
            {/* O Provider envelopa o Layout e todas as páginas internas */}
            <Route
              element={
                <WorkspacesProvider>
                  <AppLayout />
                </WorkspacesProvider>
              }
            >
              <Route index element={<Navigate to={paths.workspaces} replace />} />
              <Route path={paths.workspaces} element={<WorkspacesPage />} />
              <Route path={paths.workspace()} element={<WorkspacePage />} />
              <Route path={paths.workspaceSettings()} element={<WorkspaceSettingsPage />} />
              <Route path={paths.codex()} element={<CodexPage />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
